/**
 * @generated SignedSource<<867597cd1e38609acdd1ea12f4f942c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateSessionInputObject = {
  email: string;
  password: string;
};
export type login_CreateSessionMutation$variables = {
  createSessionInput: CreateSessionInputObject;
};
export type login_CreateSessionMutation$data = {
  readonly createSession: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly token: string | null | undefined;
    readonly user: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type login_CreateSessionMutation = {
  response: login_CreateSessionMutation$data;
  variables: login_CreateSessionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "createSessionInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "createSessionInput",
    "variableName": "createSessionInput"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "login_CreateSessionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateSessionMutationPayload",
        "kind": "LinkedField",
        "name": "createSession",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "login_CreateSessionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateSessionMutationPayload",
        "kind": "LinkedField",
        "name": "createSession",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6947531f10c99486afb3a6fe1df433bc",
    "id": null,
    "metadata": {},
    "name": "login_CreateSessionMutation",
    "operationKind": "mutation",
    "text": "mutation login_CreateSessionMutation(\n  $createSessionInput: CreateSessionInputObject!\n) {\n  createSession(createSessionInput: $createSessionInput) {\n    user {\n      id\n    }\n    token\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bc8c9d7834e41139cea4ec60f5400d2f";

export default node;
